$(document).ready(function () {
  // Get all gallery sliders - there could be multiple on the page
  const sliders = $('.gallery-slider');

  sliders.each(function (idx, element) {
    const slider = $(element);

    // Initialise slick on each slider
    slider.slick({
      infinite: true,
      speed: 500,
      arrows: false,
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '275px',
      responsive: [
        {
          breakpoint: 640,
          settings: {
            centerPadding: '26px'
          }
        },
        {
          breakpoint: 1280,
          settings: {
            centerPadding: '67px'
          }
        }
      ]
    });

    const nextArrows = slider
      .closest('.gallery-container')
      .find('.gallery-slider-next-btn');
    const prevArrows = slider
      .closest('.gallery-container')
      .find('.gallery-slider-prev-btn');

    nextArrows.on('click', (event) => {
      const s = $(event.currentTarget).attr('data-id');
      $(`.gallery-slider-${s}`).slick('slickNext');
    });

    prevArrows.on('click', (event) => {
      const s = $(event.currentTarget).attr('data-id');
      $(`.gallery-slider-${s}`).slick('slickPrev');
    });
  });
});
